// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSwapRightOutlinedSvg from "@fishx/icons-svg/es/asn/PSwapRightOutlined";
import FishxIcon from '../components/FishxIcon';

var PSwapRightOutlined = function PSwapRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSwapRightOutlinedSvg
  }));
};

PSwapRightOutlined.displayName = 'PSwapRightOutlined';
export default React.forwardRef(PSwapRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSwapRightOutlined.js
// module id = 3672
// module chunks = 0